"use client";

import { c as _c } from "react/compiler-runtime";
import { formatDistanceToNow } from "date-fns";
import { Key, Copy, MoreVertical, Shield } from "lucide-react";
import { Badge } from "@/lib/components/badge";
import { Button } from "@/lib/components/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/lib/components/card";
import { mockApiKeys } from "@/lib/mock-feature-data";
import { formatNumber } from "@llmgateway/shared/number-format";
export function ApiKeyDemo() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CardHeader><CardTitle>API Key Management</CardTitle><CardDescription>Securely manage and monitor your API keys</CardDescription></CardHeader>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = mockApiKeys.map(_temp);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Shield className="h-5 w-5 text-muted-foreground mt-0.5" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Card>{t0}<CardContent><div className="space-y-4">{t1}<div className="mt-6 p-4 rounded-lg border border-dashed border-muted-foreground/30 bg-muted/30"><div className="flex items-start gap-3">{t2}<div className="space-y-1"><p className="font-medium">Secure Key Storage</p><p className="text-sm text-muted-foreground">All API keys are encrypted at rest and in transit. Keys are only shown once during creation and cannot be retrieved later.</p></div></div></div></div></CardContent></Card>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(apiKey) {
  return <div key={apiKey.id} className="flex items-center justify-between p-4 rounded-lg border bg-card hover:shadow-md transition-shadow"><div className="flex items-center gap-4"><div className="p-2 rounded-lg bg-primary/10"><Key className="h-5 w-5 text-primary" /></div><div className="space-y-1"><div className="flex items-center gap-2"><p className="font-semibold">{apiKey.name}</p><Badge variant="outline" className="text-xs">{apiKey.status}</Badge></div><div className="flex items-center gap-3 text-sm text-muted-foreground"><code className="text-xs bg-muted px-2 py-1 rounded">{apiKey.keyPrefix}••••{apiKey.lastFour}</code><span>•</span><span>{formatNumber(apiKey.usageCount)} requests</span><span>•</span><span>Last used{" "}{formatDistanceToNow(apiKey.lastUsed, {
              addSuffix: true
            })}</span></div></div></div><div className="flex items-center gap-2"><Button variant="ghost" size="icon"><Copy className="h-4 w-4" /></Button><Button variant="ghost" size="icon"><MoreVertical className="h-4 w-4" /></Button></div></div>;
}